import { Stack, Typography } from "@mui/material";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import DashboardTable from "../../../components/Dashboard/DashboardTable";
import Template from "../../../components/Dashboard/Template";

const headerData = [];

const diplayRows = ["date_and_month", "order_owner_data", "showDetailBtn"];

function AllRecentSales({ tableData, isLoading }) {
  const navigate = useNavigate();
  const handleNavigateToDetail = (row) => {
    navigate(`/supplier/sale/detail/${row?._id}`);
  };

  return (
    <Template primaryHeading={t("recentSale")} secondaryHeading={t("latest")}>
      {tableData?.length > 0 ? (
        <DashboardTable
          headerData={headerData}
          tableData={tableData}
          diplayRows={diplayRows}
          handleNavigateToDetail={handleNavigateToDetail}
        />
      ) : isLoading === false && tableData?.length === 0 ? (
        <Stack height={"100%"} alignItems={"center"} justifyContent={"center"}>
          <Typography variant="h5" fontWeight={600}>
            {t("noDataFound")}!
          </Typography>
        </Stack>
      ) : null}
    </Template>
  );
}

export default AllRecentSales;
